// extracted by mini-css-extract-plugin
module.exports = {"Product":"bodyWrapper_Product__UlQ3f","Body":"bodyWrapper_Body__RrlUQ","Left":"bodyWrapper_Left__vLAB6","Right":"bodyWrapper_Right__23W9b","MainInfo":"bodyWrapper_MainInfo__28S8b"};